export function getDeviceId() {
    let deviceId = localStorage.getItem("device_id");

    if (!deviceId) {
        try {
            if (typeof crypto !== 'undefined' && crypto.randomUUID) {
                deviceId = crypto.randomUUID();
            }
            else {
                deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    const r = (Math.random() * 16) | 0;
                    const v = c === 'x' ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                });
            }
        } catch (error) {
            deviceId = `device-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        }

        localStorage.setItem("device_id", deviceId);
    }

    return deviceId;
}



//export function getDeviceId() {
//    let deviceId = localStorage.getItem("device_id");

//    if (!deviceId) {
//        deviceId = crypto.randomUUID();
//        localStorage.setItem("device_id", deviceId);
//    }

//    return deviceId;
//}